<template>
    <!-- 1. Menu contents Guide  -->
    <div class="collapse menu-contents" v-bind:class="{show:isGuide}" id="Guide">
        <div class="menu-body menu-search">
            <div class="menu-inner">

                <!-- contents -->
                <div class="menu-static">
                    <div class="clearfix mb10">
                        <div class="guide-close-wrap">
                            <a class="guide-close btn btn-secondary" @click="closeguide">
                                閉じる
                                <i class="material-icons">close</i>
                            </a>
                        </div>
                        <h2 class="menu-tit">{{title}}</h2>
                        <br>
                        <div id="contentview" v-html="guideString">
                    </div>
                </div>
            </div>
        </div>
    </div><!-- / menu-contents -->
    </div>
</template>
<script>
var marked = require('marked');
import store from '../store'
import {API_URL} from '@/services/config'

export default {
  name: "GuideView",
  props: {
    msg: String
  },
  computed:{
    isGuide(){
      return this.$store.getters.isGuide;
    }
  },
  data(){
      return {
        title:'',
        guideString:''
      }
  },
  mounted(){
    var self=this;
    var params = new URLSearchParams();
    params.append('menu_id',9999);
    self.$axios.post(`${API_URL}/search/getcontent`, params)
    .then((res)=>{
        self.guideString = marked((res.data.contentValue === null) ? '' : res.data.contentValue, { breaks: true })
        self.title = res.data.title; 
    })
    .catch(err=>{
        console.log('err end');
    });

  },
  methods: {
     closeguide(){
      this.$store.dispatch('upIsGuide', false);
    }

  }
};
</script>